/* unplugin-vue-components disabled */import { render } from "./three.vue?vue&type=template&id=aaad72f4&scoped=true"
import script from "./three.vue?vue&type=script&lang=js"
export * from "./three.vue?vue&type=script&lang=js"

import "./three.vue?vue&type=style&index=0&id=aaad72f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaad72f4"]])

export default __exports__